import { toast, type ToastProps } from "@octopus-energy/coral/atoms"
import { useTranslations } from "next-intl"
import { type IntlKeys } from "@/features/translations"

export function useToast() {
    const t = useTranslations("useToast")

    // Waiting for Coral typing resolution: https://krakentech.slack.com/archives/C02QAKGBS0K/p1764347634787529
    return (message: IntlKeys<"useToast">, options: ToastProps) => toast(t(message), options)
}

useToast.messages = ["useToast"] as const
